export { default as useCompactWorkspaceSecondaryMenuTotals } from './useCompactWorkspaceSecondaryMenuTotals';
